/**
 * Funcion que retorna la expresion regular para la validacion del correo electronico
 */
export const getPatterEmail = () => {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
};

//Convertir un numero a formato moneda
export const convertCurrencyNumber = (number) => {
  return new Intl.NumberFormat("de-DE").format(number);
};

/**
 * Arma el contexto que esperaban los manejadores del Select de codekit, para que
 * pasar a <select> nativo no obligue a reescribir ninguno. El DOM solo devuelve
 * texto, asi que la opcion se busca comparando como texto.
 * @param {Array} options Opciones de la lista
 * @param {string} chosen Valor escogido
 * @returns {object} Objeto con la opcion original, con label si no la traia
 */
export const buildContext = (options, chosen) => {
  const found = options.find((option) => String(option.value) === chosen);
  return { option: found ? { label: found.text, ...found } : { value: chosen, text: "", label: "" } };
};

/**
 * Pinta las opciones de una lista, con el rotulo vacio de siempre al comienzo.
 * @param {Array} options Opciones de la lista
 * @returns Component
 */
export const renderOptions = (options) => [
  <option key="" value="">
    Seleccione una opción
  </option>,
  ...options.map((option) => (
    <option key={option.value} value={option.value}>
      {option.text}
    </option>
  )),
];

//Deja solo los digitos de lo que se escribio, que es lo que se guarda: las
//columnas de dinero de la oferta son DECIMAL(12,0), sin decimales
export const onlyDigits = (value) => {
  return String(value ?? "").replace(/\D/g, "");
};

//Muestra un valor de dinero con separador de miles, como el resto de CIMA
export const toCurrencyText = (value) => {
  const digits = onlyDigits(value);
  return digits === "" ? "" : convertCurrencyNumber(Number(digits));
};

//Funcion para convertir blob a File
export function blobToFile(blob, fileName) {
  blob.lastModifiedDate = new Date();
  blob.name = fileName;
  return blob;
}

//Funcion que retorna la fecha actual
export const getActualDate = () => {
  let dateActual = new Date();
  let year = dateActual.getFullYear();
  let month = (dateActual.getMonth() + 1).toString().padStart(2, "0");
  var day = dateActual.getDate().toString().padStart(2, "0");
  return year + "-" + month + "-" + day;
};

//Funcion para convertir la primera palabra de un string a Mayuscula
export const convertString = (value) => {
  const splitName = value.split(" ");
  const finalString = splitName.map((word) => {
    return word !== "" ? word[0].toUpperCase() + word.slice(1).toLowerCase() : "";
  });
  return finalString.join(" ");
};

/**
 * Funcion para validar si una fecha es menor o mayor a la fecha actual
 * Retorna true si es mayor y false si es menor
 * @param string date
 * @returns boolean
 */
export const validateDate = (date) => {
  let dateValidate = new Date(date);
  let today = new Date();
  if (dateValidate >= today) {
    return true;
  } else {
    return false;
  }
};

/**
 * Funcion para validar si el momento actual esta dentro del horario laboral
 */
export function isWorkingDay(actualDate = new Date()) {
  const day = actualDate.getDay();
  const hour = actualDate.getHours();
  const minutes = actualDate.getMinutes();
  const totalMinutes = hour * 60 + minutes;
  if (day >= 1 && day <= 5) {
    // Lunes a Viernes 8 a 17
    return totalMinutes >= 8 * 60 && totalMinutes < 17 * 60;
  } else if (day === 6) {
    // Sabado 8 a 12
    return totalMinutes >= 8 * 60 && totalMinutes < 12 * 60;
  }
  return false;
}

/**
 * Funcion para consultar el id del archivo cargado a genio dentro de las cookies
 */
export function getIdByCookie(name) {
  const value = document.cookie.split("; ").find((row) => row.startsWith(name + "="));
  return value ? value.split("=")[1] : "";
}

/**
 * Funcion para limpiar el valor de una cookie
 */
export function clearValueCookie(name) {
  document.cookie = `${name}=""; path=/; domain=.repremundo.com.co; Secure; SameSite=Lax`;
}

/**
 * Convierte un valor de moneda formateado (string o number)
 *
 */
export function cleanCurrencyValue(value)  {
  if (value === undefined || value === null || value === "") return 0;

  if (typeof value === "number") return value;
  let cleaned = String(value);
  const isEuropean = cleaned.includes(',') && (cleaned.includes('.') || cleaned.indexOf(',') > cleaned.indexOf('.'));

  if (isEuropean) {
    cleaned = cleaned.replace(/\./g, '').replace(',', '.');
  } else {
    cleaned = cleaned.replace(/,/g, '');
  }

  const result = parseFloat(cleaned);
  return isNaN(result) ? 0 : result;
};
